/* eslint-disable */
// import external dependencies
// import 'jquery';
// import 'bootstrap';

import './custom/swiper';
import './custom/support';
import './custom/icons';
import './custom/accordion';
import './custom/carousel';
import './custom/team-members';
import './custom/scrollTo';
import './custom/occasions';
import './custom/header';
import './custom/custom-validity';
import './custom/autofocus-on-gravity-forms';
import './custom/show-loader-on-gravity-form-submit';
import './custom/trap-focus';
import './custom/skip-link';
import './custom/datepicker-nl';
import './custom/navigation';
import './custom/occasion-dealer-info-modal';

import './web-components';
import './custom/google-maps-loader';



// WEBPACK FOOTER //
// ./scripts/main.js